import { Button } from '@components/Buttons/Base'
import { Spacer } from '@components/Spacer'
import { useDesignatedDonation } from '@features/checkout/hooks/useDesignatedDonation'
import { useOrg } from '@features/organizations/hooks/useOrganizations'
import { CustomSpacer } from '@features/teams/components/CustomSpacer'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'
import React from 'react'
import {
  ActivityIndicator,
  Platform,
  StyleSheet,
  Text,
  View
} from 'react-native'
import { CircleImage } from '~/Components/CircleImage/Original'

export function GiveMoreDetails(props: { aliasOrValias: string }) {

  React.useEffect(() => {
    if (Platform.OS === 'web' && typeof document !== 'undefined') {
      const script = document.createElement('script')
      script.src = 'https://cdn.givechariot.com/components/chariot-components.umd.js'
      script.async = true
      document.head.appendChild(script)
    }
  }, [])

  const { donate } = useDesignatedDonation({
    type: 'org',
    aliasOrValias: 'givemore',
  })

  const query = useOrg(props.aliasOrValias)

  if (query.isLoading || query.isLoadingError)
    return (
      <View style={styles.container}>
        <ActivityIndicator />
      </View>
    )

  if (query.data != null) {

    return (
      <View role="banner" style={styles.container}>
        <CustomSpacer height={30} />

        <View style={styles.centerWrapper}>
          <View>
            <CircleImage
              image={'/mark_pink.svg'}
              size={100}
              borderWidth={1}
              fallbackToGradient
              hideShadow
            />
          </View>
        </View>

        <CustomSpacer height={18} />

        <View style={styles.centerWrapper}>
          <Text style={styles.title}>Welcome to Give More!</Text>
        </View>

        <CustomSpacer height={18} />

        <View style={styles.headerRow}>
          <Text style={styles.description}>
            We've made it easy to go about your daily life and experience
            the joys of generosity. Give More allows you to make a one-
            time donation and we'll meet urgent needs for you. You'll join
            a growing community we're calling, "The Neighbors," to
            support urgent needs in real-time each month.
          </Text>
          <Spacer height={15} />
          <Text style={styles.description}>
            If you're coming from NCF and other donor advised funds,
            this is the place! There's now a transparent way to see the
            direct impact you are having with your giving and know how
            your funds are being used.
          </Text>
          <Spacer height={15} />
          <Text style={styles.description}>
            Simply select a payment method below, share any impact
            preferences (e.g., geography) in the giving notes or by
            emailing support@purposity.com, and we'll do the rest. We'll
            send a report each month that highlights what The Neighbors
            are accomplishing with their generosity!
          </Text>
        </View>

        <CustomSpacer height={40} />

        <View style={styles.centerWrapper}>
          <View style={styles.buttonRow}>
            <Button
              format="rounded"
              fullFlex
              size="regular"
              title="Give With Card"
              onClick={() => donate()}
              spaced
              padding={{
                paddingTop: 14,
                paddingBottom: 14,
              }}
            />
            <CustomSpacer height={10} />

            <chariot-button
              style={styles.buttonDark}
              cid="live_a33e639eb05daf01e8b138f1474af160f6d9890c93a1d9c4873f8015cd234623">
            </chariot-button>

          </View>
        </View>
      </View>
    )
  }

  return null
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'chariot-button': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement> & { cid: string }, HTMLElement>;
    }
  }
}

const styles = StyleSheet.create({
  title: {
    fontFamily: Fonts.type.alternateBold,
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
    color: Colors.black,
  },
  container: {
    minHeight: 250,
    flexGrow: 0,
    flexShrink: 0,
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    backgroundColor: Colors.white,
  },
  centerWrapper: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  orgNameHolder: {
    flexGrow: 1,
    width: '100%',
  },
  orgName: {
    alignSelf: 'flex-start',
    color: Colors.alternateGray,
    fontFamily: Fonts.type.bold,
    fontWeight: 'bold',
    fontSize: 22,
    lineHeight: 22,
    marginTop: 8,
  },
  description: {
    color: '#646670',
    fontFamily: Fonts.type.regular,
    fontSize: 16,
    lineHeight: 22,
  },
  sectionSeparator: {
    height: StyleSheet.hairlineWidth,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'stretch',
    flexGrow: 0,
    backgroundColor: Colors.altWhite,
    paddingHorizontal: 16,
  },
  headerRow: {
    flexDirection: 'column',
    overflow: 'hidden',
    paddingHorizontal: 16,
  },
  buttonRow: {
    flexDirection: 'column',
    overflow: 'hidden',
    width: '400px',
  },
  buttonDark: {
    backgroundColor: Colors.black,
    paddingVertical: 16,
    paddingHorizontal: 24,
    borderRadius: 32,
  },
  buttonPrimary: {
    height: 20,
  },
})
